import { render, staticRenderFns } from "./FormItemRemind.vue?vue&type=template&id=55f98004&scoped=true&"
import script from "./FormItemRemind.vue?vue&type=script&lang=js&"
export * from "./FormItemRemind.vue?vue&type=script&lang=js&"
import style0 from "./FormItemRemind.vue?vue&type=style&index=0&id=55f98004&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f98004",
  null
  
)

export default component.exports